module.exports = __webpack_public_path__ + "static/media/general-de-seguros-pin.fe0361d4.svg";